import {firestore} from '../firebaseIndex'

///////////////////////////////////////////////////////////////////////////////
export const addOrgChart = async (domainId, contractId, data ) => {
    try {
        const res = await firestore.collection('DOMAINS')
            .doc(domainId).collection('contracts')
            .doc(contractId).collection('organizationcharts')
            .add(data);
        const newdata = {
            ...data,
            id: res.id,
        }
        return newdata
    } catch (e) {
        console.log("addOrgChart error: ", e)
        return { error: e }
    }
}




///////////////////////////////////////////////////////////////////////////////
export const getOrgChartById = async (domainId, contractId, orgchartId) => {
    try {
        const res = await firestore.collection('DOMAINS')
            .doc(domainId).collection('contracts')
            .doc(contractId)
            .collection('organizationcharts')
            .get(orgchartId)

        const firebaseData = res.data()
        const data = {
            ...firebaseData,
            id : res.id,
        }
        return data;
    } catch (e) {
        console.log("getOrgChart error: ", e)
        return { error: e }
    }
}


///////////////////////////////////////////////////////////////////////////////
export const getOrgChartList = async (domainId, contractId, subject=null) => {
    try {
        if (subject === null || subject === undefined) {
            const res = await firestore.collection('DOMAINS')
                .doc(domainId).collection('contracts')
                .doc(contractId)
                .collection('organizationcharts')
                .get();

            const orgchartList = res.docs.map(doc => {
                const firebaseData = doc.data()
                const data = {
                    ...firebaseData,
                    id : doc.id,
                }
                return data
            })
            return orgchartList;
        } else {
            const res = await firestore.collection('DOMAINS')
                .doc(domainId).collection('contracts')
                .doc(contractId)
                .collection('organizationcharts')
                .where('subject', '==', subject)
                .get();

            const orgchartList = res.docs.map(doc => {
                const firebaseData = doc.data()
                const data = {
                    ...firebaseData,
                    id : doc.id,
                }
                return data
            })
            return orgchartList;
        }
    } catch (e) {
        console.log("getOrgChartList error: ", e)
        return { error: e }
    }
}




///////////////////////////////////////////////////////////////////////////////
export const editOrgChart = async (domainId, contractId, orgchartId, data) => {
    try {
        const orgchart =  firestore.collection('DOMAINS')
            .doc(domainId).collection('contracts')
            .doc(contractId)
            .collection('organizationcharts')
            .doc(orgchartId);

        const res = await orgchart.set(data)
            .then( () => {
                console.log("editOrgChart - edit successfully")
                return data
            }).catch( error => {
                console.log("editOrgChart - edit error: ", error)
                return {error: error}
            });

        return res
    }  catch (e) {
        console.log("editOrgChart error: ", e)
        return { error: e }
    }
}


///////////////////////////////////////////////////////////////////////////////
export const deleteOrgChart = async (domainId, contractId, orgchartId) => {
    try {
        const res = await firestore.collection('DOMAINS')
            .doc(domainId).collection('contracts')
            .doc(contractId)
            .collection('organizationcharts')
            .doc(orgchartId).delete();
        return res
    }  catch (e) {
        console.log("deleteOrgChart error: ", e)
        return { error: e }
    }
}



